export class MapLayerControl {
  map: any;
  container: any;

  constructor(container) {
    this.container = container;
  }

  onAdd(map){
    this.map = map;
    return this.container;
  }

  onRemove(){
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}
